import React, { useEffect, useRef, useState } from 'react';
let pos = { top: 0, left: 0, x: 0, y: 0 };
import Siema from 'siema';
import ArrowBack from '@material-ui/icons/ArrowBackIos';
import { IconButton } from '@material-ui/core';
import PizzaViewer from './Pizza-Viewer';
import { modelCardProps, ModelDetail } from '../types/modelcard';
import SimpleViewer from './Simple-Viewer';

export default function Courasel(props: { images: string[]; className?: string; FeaturedAsset: ModelDetail }) {

    const hasButtons = props.images.length > 1 || props.FeaturedAsset && props.images.length > 0;

    //Init courasel
    const siema = useRef<Siema>();
    useEffect(() => { siema.current = new Siema({ loop: true, draggable: hasButtons }) }, [])

    // const model = { "Title": "Alpaca", "UploadDate": "2021-09-07T03:23:36.128Z", "ResourceID": "444228bb-745d-49b2-89ef-cc12805deaa8", "PublicID": "bCVFD48i2l", "Likes": 1, "CommentCount": 0, "Tris": 1998, "Views": 55, "Downloads": 11, "Creator": { "Username": "Quaternius", "DPURL": "https://static.poly.pizza/dp%2Ff63b655a-051c-4c4b-8dcc-3b346a39ece0.jpg", "Socials": { "Twitter": "quaternius", "Pateron": "quaternius", "Website": "https://quaternius.com/" } }, "Category": "Animals", "Tags": ["Animal", "Wildlife"], "Orbit": { "phi": "1.21439", "radius": "100%", "theta": "0.85142" }, "Background": { "one": "#039be5", "two": "hsl(200deg, 97%, 15%)", "type": "Radial" }, "Visibility": "Public", "Type": "FBX", "Licence": "CC0 1.0", "Animated": true };

    return (
        <div className={"overflow-hidden relative aspect-video" + props.className}>
            <div className={`siema`}>
                {/* 1 Featured model at start*/}
                {props.FeaturedAsset && <SimpleViewer model={props.FeaturedAsset} className='w-full h-full aspect-video' />}

                {/* Courasel images */}
                {
                    props.images.map((image, index) => {
                        return <img key={index} src={image} className="w-full h-full object-cover aspect-video select-none" />
                    })
                }

                {/* Placeholder if no images */}
                {props.images.length === 0 && <img src={'/img/placeholder.png'} className="w-full h-full object-cover aspect-video select-none" />}
            </div>

            {/* Buttons */}
            {
                hasButtons && [...Array(2)].map((e, i) =>
                    <div className={`absolute top-0 h-full flex justify-center items-center px-3 ${i == 0 ? 'left-0' : 'right-0'}`}>
                        <IconButton onClick={() => { i == 0 ? siema.current.prev() : siema.current.next() }} size={'medium'} className={i == 1 && 'scale-x-[-1]'} ><ArrowBack className='translate-x-1' /></IconButton>
                    </div>
                )
            }

        </div>
    );
}